export default __webpack_public_path__ + "static/video-poster-3131256f792c672dd65d5a3f7fa8b933.jpg";